export const business = {
  legalName: "Guangzhou Nexus Supply Chain Co., Ltd.",
  chineseName: "广州尼克索斯供应链有限公司",
  streetAddress: "Room A3655, 28/F, Building 371-1, Wushan Road, Tianhe District",
  address: "Room A3655, 28/F, Building 371-1, Wushan Road, Tianhe District, Guangzhou, China",
  telephone: "+86 134 2415 3995",
  whatsappUrl: "https://wa.me/8613424153995",
} as const;
